import React, { Component } from "react" 
import { NavLink } from 'react-router-dom'

import { Logo, Img } from "../UI/UI";
import { isMobile } from "../../Utility/Utility";
import "./Menu.css";





class Menu extends Component {
  state = {
    isOpen : false
  }

  setMenuState = () => {
   if ( this.state.isOpen ){    
      this.setState({
        isOpen : !this.state.isOpen
      })
    }else {
      this.setState({
        isOpen : !this.state.isOpen
      })
    }
  } 
  

 
  render(){
    
  
    let cssClass ="inner";
  

    if ( this.state.isOpen === true ) {
      cssClass += " open"
    }

  

    return(
    <div>
      {this.state.isLangOpen && <div className="nav-trigger-overlay" onClick={this.setLangState}></div>}
      <div className="menu-outer-wrapper">
        <div className="container">
          <div className="col col-15 logo-outer-wrapper">
            <NavLink  exact  className="first" to="/">
              <Logo />
            </NavLink>
          </div>
          <div className="col col-100 menu-inner-wrapper">
            <div className={cssClass}>
              <NavLink  exact  className="first" to="/">HOME</NavLink>
              <NavLink  exact to="/Pages/bestDeals">BEST DEALS</NavLink>
              <NavLink  exact to="/Pages/SitesOfSignificance">SITES OF SIGNIFICANCE</NavLink>{/*WHERE TO GO*/} 
              <NavLink  exact to="/Pages/ItinerariesPage">ITINERARIES </NavLink>{/*THINGS TO DO*/}
              <NavLink  exact to="/Pages/Gallery/">GALLERY</NavLink>
              {/* <NavLink  exact to="/Pages/Testimonials">TESTIMONIALS</NavLink> */}
              <NavLink  exact  to="/Pages/Resources">RESOURCES</NavLink>
              <NavLink  exact to="/Pages/InfoForPastors">INFO FOR PASTORS</NavLink>
              <NavLink  exact  to="/Pages/FAQ">FAQ</NavLink>
            
           
              
            </div>
            <div className="show-on-mobile">
              <button className="open-mobile-menu navbar-toggle" onClick={this.setMenuState} >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
     
        </div>
    )
  }
}


export default Menu


// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js